import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { toast } from 'sonner';

interface ApiErrorResponse {
  detail?: string;
}

const DEFAULT_ERROR_MESSAGE = 'Xatolik yuz berdi.';

const showErrorToast = (error: unknown) => {
  if (!axios.isAxiosError<ApiErrorResponse>(error)) {
    toast.error(DEFAULT_ERROR_MESSAGE);
    return;
  }

  const status = error.response?.status;

  // 401 va 403 holatlari Axios interceptor ichida boshqariladi.
  if (status === 401 || status === 403) return;

  toast.error(error.response?.data?.detail || DEFAULT_ERROR_MESSAGE);
};

const mutationCache = new MutationCache({
  onError: showErrorToast,
});

const queryCache = new QueryCache({
  onError: showErrorToast,
});

export const queryClient = new QueryClient({
  queryCache,
  mutationCache,
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      // refetchOnMount: false,
      // refetchOnReconnect: false,
      staleTime: 5 * 60 * 1000,
      cacheTime: 5 * 60 * 1000,
      retry: 1,
    },
  },
});
